import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  DatePicker,
  Input,
  Select,
  Space,
  Grid,
} from "antd";
import {
  DownloadOutlined,
  FilterOutlined,
  SearchOutlined,
  SwapOutlined,
  UploadOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { select_search } from "../../Controllers/Global";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { debounce } from "lodash";
import Container from "../Container";

import {
  handleDateKeyDown,
  handleDateInput,
  handleDateBlur,
  blockPaste,
} from "../../Componets/Formcomponents/dateUtility";


const { useBreakpoint } = Grid;

const Header = (props) => {
  const { headers, setHeaders, formdata } = props;
  const { RangePicker } = DatePicker;
  let navigate = useNavigate();
  const headerRef = useRef();
  const lastScannedBarcode = useRef("");
  const screens = useBreakpoint();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(true);


  const handleSearch = debounce((e, i) => {
    const inputValue = e?.target?.value?.trim();

    if (inputValue === lastScannedBarcode.current) return;
    console.log("input valueeeee", inputValue)

    headers.components[i].value = inputValue;
    setHeaders({ ...headers });
    handleFormData();

    lastScannedBarcode.current = inputValue;
  }, 500);

  const handleFormData = () => {
    let data = {};

    console.log("headers", headers)
    headers?.components?.forEach((value) => {
      data[value.name] = value.value;
    });

    console.log("🔎 Filter data being sent:", data);
    formdata(data);
  };

  const handleSelect = (e, i) => {

    headers.components[i].value = e;
    setHeaders({ ...headers });
    handleFormData();
  };

  const handleDate = (e, i) => {
    let date = "";

    if (e?.$d) {
      let localDate = new Date(e?.$d ? e?.$d : new Date());
      localDate.setMinutes(
        localDate.getMinutes() - localDate.getTimezoneOffset()
      );

      date = localDate.toISOString();
    }

    headers.components[i].value = date;
    setHeaders({ ...headers });
    handleFormData();
  };

  const handleRange = (e, i) => {
    let start_date = "";
    let end_date = "";

    if (e?.[0]?.$d && e?.[1]?.$d) {
      let localDateStart = new Date(e?.[0]?.$d ? e?.[0]?.$d : new Date());
      localDateStart.setMinutes(
        localDateStart.getMinutes() - localDateStart.getTimezoneOffset()
      );

      let localDateEnd = new Date(e?.[1]?.$d ? e?.[1]?.$d : new Date());
      localDateEnd.setMinutes(
        localDateEnd.getMinutes() - localDateEnd.getTimezoneOffset()
      );

      start_date = localDateStart?.toISOString();
      end_date = localDateEnd?.toISOString();
    }

    headers.components[i].value = {
      start: start_date,
      end: end_date,
    };
    setHeaders({ ...headers });
    handleFormData();
  };

  const handleTabs = (e) => {
    return e?.map((value, index) => ({
      title: value?.name,
      onClick: () => navigate(value?.path),
      className:
        value?.path && index !== e?.length - 1
          ? "text-black-200 cursor-pointer hover:text-[#2d53da]"
          : value?.path && index === e?.length - 1
            ? "breadcrumb-tab-color cursor-pointer hover:text-[#2d53da]"
            : "text-black",
    }));
  };

  const handleMenu = (e) => {
    return e?.map((value) => ({
      title: value?.name,
      onClick: () => navigate(value?.path),
      className: value?.path ? "cursor-pointer hover:text-[#2d53da]" : "",
    }));
  };

  const latestQueryRef = useRef({});

  const handleSelectSearch = async (e, index) => {

    const query = e;
    latestQueryRef.current[index] = query;

    let data = { ...headers };

    if (data.components[index].api) {
      const select = {
        api: data.components[index].api,
        search: query,
        status: 1,
      };

      const search = await select_search(select);

      if (latestQueryRef.current[index] !== query) return;

      if (search?.status) {
        let options = [];

        if (data.components[index].name === "purchase") {
          options = search?.data?.data.map((value) => ({
            value: value._id,
            label: `#PO-${value.number}`,
          }));
        } else if (data.components[index].name === "received") {
          options = search?.data?.data.map((value) => ({
            value: value._id,
            label: `#${value.number}`,
          }));
        } else if (data.components[index].name === "customer") {
          options = search?.data?.data.map((value) => ({
            value: value?._id,
            label:
              value?.name && value?.phone
                ? `${value?.name} (${value?.phone})`
                : value?.name || value?.phone || "",
          }));
        } else if (data.components[index].name === "branch") {
          options = search?.data?.data.map((value) => ({
            value: value?._id,
            label:
              value?.name && value?.phone
                ? `${value?.name} (${value?.phone})`
                : value?.name || value?.phone || "",
          }));
          options?.push({ value: "ALL", label: "ALL" });
        } else {
          options = search?.data?.data.map((value) => ({
            value: value._id,
            label: value.name,
          }));
        }

        data.components[index].options = options;
        setHeaders(data);
      } else {
        toast.error(search.message);
      }
    }
  };

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const dateFormatList = ["DD/MM/YYYY", "DD-MM-YYYY"];

  useEffect(() => {
    headerRef?.current?.focus();
  }, []);

  const componentCount = headers?.components?.length || 0;
  const hasRange = headers?.components?.some((c) => c.type === "range");
  const rangeCount = headers?.components?.filter((c) => c.type === "range").length;


  let headerHeight = "50px";
  if (componentCount === 0) {
    headerHeight = "50px";
  } else if (componentCount <= 5 || componentCount <= 7 && rangeCount <= 1 || componentCount <= 8 && (!hasRange)) {
    headerHeight = "130px";
  } else if (componentCount > 5 && componentCount <= 8) {
    headerHeight = "180px";
  } else {
    headerHeight = "220px";
  }

  return (
    <div className="flex flex-col h-screen">
      <div>
        <div className="p-4 flex justify-between items-center border-b bg-white min-h-[60px] max-h-[100px]">
          <div
            className="outline-none"
            ref={headerRef}
            tabIndex={-1}
          >
            {headers?.name}
          </div>

          <div className="flex flex-wrap gap-2 justify-end">
            {headers?.components?.map((value, index) => (
              <div key={index} className={
                index + 1 === headers?.components?.length ? "" : "pr-2"
              }>
                {value?.type === "search" ? (
                  <Input
                    allowClear
                    className="search"
                    placeholder=" Search"
                    prefix={
                      <SearchOutlined className="text-gray-500 text-medium" />
                    }
                    onChange={(e) => handleSearch(e, index)}
                    onKeyDown={handleOnKeyDown}
                  />
                ) : value?.type === "select" || value?.type === "filter" ? (
                  <Select
                    allowClear={value?.allowClear}
                    showSearch={value?.showSearch}
                    filterOption={value?.filterOption}
                    className={
                      value?.className ? value?.className : "w-32"
                    }
                    placeholder={
                      <span>
                        {value?.type === "select" ? (
                          <SwapOutlined
                            style={{ transform: "rotate(90deg)" }}
                          />
                        ) : (
                          <FilterOutlined />
                        )}
                        <span className="pl-2">{value?.placeholder}</span>
                      </span>
                    }
                    options={value?.options}
                    onClick={() => handleSelectSearch("", index)}
                    onSearch={(e) => handleSelectSearch(e, index)}
                    onChange={(e) => handleSelect(e, index)}
                    onKeyDown={handleOnKeyDown}
                    autoComplete="off"
                    value={value?.value ? value?.value : null}
                  />
                ) : value?.type === "date" ? (
                  <DatePicker
                    format={dateFormatList}
                    value={value?.value && dayjs(value?.value)}
                    onChange={(e) => handleDate(e, index)}
                    onKeyDown={handleDateKeyDown}
                    onInput={handleDateInput}
                    onPaste={blockPaste}
                    onBlur={(e) =>
                      handleDateBlur(e, (date) => handleDate({ $d: date }, index))
                    }
                  />
                ) : value?.type === "range" ? (
                  <RangePicker
                    format={dateFormatList}
                    placeholder={value?.placeholder}
                    onChange={(e) => handleRange(e, index)}
                  />
                ) : value?.type === "upload" ? (
                  <Button className="text-[#BFBFBF]">
                    Export <UploadOutlined className="pl-4 pt-0.5" />
                  </Button>
                ) : value?.type === "download" ? (
                  <Button className="text-[#BFBFBF]">
                    Import <DownloadOutlined className="pl-4 pt-0.5" />
                  </Button>
                ) : value?.type === "add" ? (
                  <Button
                    type="primary"
                    onClick={() => navigate(value?.path)}
                    className="!bg-[#07b553] !border-[#07b553] hover:!bg-[#35c77e] hover:!border-[#35c77e]"                  >
                    + Add New
                  </Button>
                ) : null}
              </div>
            ))}
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="p-3 bg-gray-50 border-t md:hidden">
            <Space direction="vertical" className="w-full" size="small">
              {headers?.components?.map((value, index) => (
                <div key={index} className="w-full">
                  {value?.type === "search" ? (
                    <Input
                      allowClear
                      className="search w-full"
                      placeholder=" Search"
                      prefix={
                        <SearchOutlined className="text-gray-500 text-medium" />
                      }
                      onChange={(e) => handleSearch(e, index)}
                      onKeyDown={handleOnKeyDown}
                    />
                  ) : value?.type === "select" || value?.type === "filter" ? (
                    <Select
                      allowClear={value?.allowClear}
                      showSearch={value?.showSearch}
                      filterOption={value?.filterOption}
                      className="w-full"
                      placeholder={
                        <span>
                          {value?.type === "select" ? (
                            <SwapOutlined
                              style={{ transform: "rotate(90deg)" }}
                            />
                          ) : (
                            <FilterOutlined />
                          )}
                          <span className="pl-2">{value?.placeholder}</span>
                        </span>
                      }
                      options={value?.options}
                      onClick={() => handleSelectSearch("", index)}
                      onSearch={(e) => handleSelectSearch(e, index)}
                      onChange={(e) => handleSelect(e, index)}
                      onKeyDown={handleOnKeyDown}
                      autoComplete="off"
                    />
                  ) : value?.type === "date" ? (
                    <DatePicker
                      format={dateFormatList}
                      value={value?.value && dayjs(value?.value)}
                      onChange={(e) => handleDate(e, index)}
                      className="w-full"
                      onKeyDown={handleDateKeyDown}
                      onInput={handleDateInput}
                      onPaste={blockPaste}
                      onBlur={(e) =>
                        handleDateBlur(e, (date) => handleDate({ $d: date }, index))
                      }
                    />
                  ) : value?.type === "range" ? (
                    <RangePicker
                      format={dateFormatList}
                      placeholder={value?.placeholder}
                      onChange={(e) => handleRange(e, index)}
                      className="w-full"
                    />
                  ) : value?.type === "upload" ? (
                    <Button className="text-[#BFBFBF] w-full">
                      Export <UploadOutlined className="pl-2" />
                    </Button>
                  ) : value?.type === "download" ? (
                    <Button className="text-[#BFBFBF] w-full">
                      Import <DownloadOutlined className="pl-2" />
                    </Button>
                  ) : value?.type === "add" ? (
                    <Button
                      type="primary"
                      onClick={() => navigate(value?.path)}
                      className="!bg-[#07b553] !border-[#07b553] hover:!bg-[#35c77e] hover:!border-[#35c77e]"                    >
                      + Add New
                    </Button>
                  ) : null}
                </div>
              ))}
            </Space>
          </div>
        )}

        <div className="p-4 bg-white border-b h-[40px] flex  items-center text-xs text-medium text-gray-400 uppercase">
          <Breadcrumb
            className="text-regular"
            separator=">"
            items={handleMenu(headers?.navigate?.path)}
          />
          <Breadcrumb
            className="text-regular"
            separator=">"
            items={handleTabs(headers?.navigate?.tabs)}
          />
        </div>
      </div>
      <Container>{props?.children}  </Container>
    </div>
  );
};

export default Header;